module.exports = __webpack_public_path__ + "static/img/home_new19.52e88217.jpg";